import styled from 'styled-components';
import { Buttons, FlexContainer } from '@taxdown/piccolo-web';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const CompensationBoxContainer = styled(FlexContainer)<{ $compensation: boolean }>`
  position: relative;
  border-radius: ${({ theme: { sizing } }) => sizing.fds_borderradius_L};
  padding: ${({ theme: { reference } }) => reference.dimension_08};
  background-color: ${({ theme: { system }, $compensation }) =>
    !$compensation
      ? system.background.fds_sys_color_background_supersoft
      : system.background.fds_sys_color_background_cold};
  border: ${({ $compensation, theme: { system } }) =>
    !$compensation ? `1px dotted ${system.border.fds_sys_color_border_primary}` : 'none'};
  width: 100%;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;

export const CloseButton = styled(Buttons.Icon)`
  position: absolute;
  top: -5px;
  right: -5px;
`;
